module.exports = __webpack_public_path__ + "static/img/scare4.504a30f4.png";